// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__maQJg","label":"Labeled_label__1ACRN","divider":"Labeled_divider__3O3r7"};